import { render, staticRenderFns } from "./FitnessplanCreateExercises.vue?vue&type=template&id=520b1861&scoped=true&"
import script from "./FitnessplanCreateExercises.vue?vue&type=script&lang=js&"
export * from "./FitnessplanCreateExercises.vue?vue&type=script&lang=js&"
import style0 from "./FitnessplanCreateExercises.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./FitnessplanCreateExercises.vue?vue&type=style&index=1&id=520b1861&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520b1861",
  null
  
)

export default component.exports